/** @jsxImportSource @emotion/react */

import { Box, css } from '@mui/material';

const IndexPage = () => {
  return <Box css={style.root}>잠시만 기다려 주세요!</Box>;
};

const style = {
  root: css`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 80px;
    font-size: 40px;
  `,
};

export default IndexPage;
